import {
    mapActions,
    mapGetters,
    mapMutations
} from 'vuex';
import FormCheck from '../Form/FormCheck/FormCheck.vue'

export default {

    components: {
        FormCheck
    },

    props: {},

    computed: {
        ...mapGetters([
            'groupements',
            'filtres',
            'tailles',
            'geometries',
            'materiaux',
            'bEtMs',
            'search',
            'searchLoading'
        ]),
    },

    data() {
        return {
            isFiltreOpen: true,
            screenWidth: 1200,
        };
    },

    watch: {},

    methods: {
        ...mapActions(['getGroupements']),
        ...mapMutations(['resetFiltres']),

        filtre(obj, Objtype) {
            obj['type'] = Objtype;
            obj['libelle'] = obj['Libelle'];
            let index = this.filtres.findIndex((filtre) => filtre.type == obj.type && filtre.libelle == obj.libelle)
            if (index >= 0) {
                this.filtres.splice(index, 1);
            }
            if (obj.selected) {
                this.filtres.push(obj);
            }
            this.search.splice(0, this.search.length);
            this.$emit('filtre');
        },

        toggleAccordeon() {
            this.isFiltreOpen = !this.isFiltreOpen
        },

        resetCurrentFiltres() {
            let checkboxes = document.getElementsByTagName('input')
            for (let i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].type == 'checkbox') {
                    checkboxes[i].checked = false;
                }
            }
            this.groupements.TYPEFLEURS.forEach(aTypeFleur => {
                aTypeFleur.selected = false
            });
            this.resetFiltres();
            this.$emit('filtre');
        },
    },
    filters: {
        toFirstUpperCase: (pText) => {
            let textLowerCase = pText.toLowerCase()
            return textLowerCase.charAt(0).toUpperCase() + textLowerCase.slice(1)
        }
    },

    mounted() {
        this.getGroupements().then(res => {
            // Rechercher des filtres déja selectionnées
            this.filtres.forEach(aFiltre => {
                if (aFiltre.selected) {
                    if (aFiltre.type === 'groupements.TYPEFLEURS') {
                        this.groupements.TYPEFLEURS.forEach(aFleur => {
                            if (aFleur.Libelle === aFiltre.Libelle) {
                                aFleur.selected = true
                            }
                        })
                    }
                }
            })

        }).catch(err => {
            console.log(err)
        })
    },

};
